module.exports = __webpack_public_path__ + "static/img/optionadv.cd54f0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/optionadv.png
// module id = WN91
// module chunks = 1